import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=ee28abb6&scoped=true&"
import script from "./ViewResult.vue?vue&type=script&lang=js&"
export * from "./ViewResult.vue?vue&type=script&lang=js&"
import style0 from "./ViewResult.vue?vue&type=style&index=0&id=ee28abb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee28abb6",
  null
  
)

export default component.exports